import React, { useEffect, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import { getSuccessfulTopUpCount } from '../calculations/successfulTopUp';
import { getFailedTopUpCount } from '../calculations/failedTopUp';
import { getTodaysTransactionsAmount } from '../calculations/todaysTransactionsAmount';

const TransactionsCard = () => {
    const [successfulCount, setSuccessfulCount] = useState(0);
    const [failedCount, setFailedCount] = useState(0);
    const [todaysTransactionsAmount, settodaysTransactionsAmount] = useState({});
    

    useEffect(() => {
        const fetchCounts = async () => {
            const success = await getSuccessfulTopUpCount();
            const failed = await getFailedTopUpCount();
            const todaysCount = await getTodaysTransactionsAmount();
            setSuccessfulCount(success);
            setFailedCount(failed);
            settodaysTransactionsAmount(todaysCount);
        };

        fetchCounts();
    }, []);

    const cards = [
        {
            title: 'Todays Transactions',
            value: (
                <div style={{ fontSize: '15px', lineHeight: '1.4', marginTop: '4px' }}>
                    {Object.keys(todaysTransactionsAmount).length > 0 ? (
                        Object.entries(todaysTransactionsAmount).map(([currency, amount]) => (
                            <div key={currency} className="d-flex justify-content-between">
                                <span className="me-2" style={{ fontWeight: 500 }}>{currency}:</span>
                                <span>{amount.toFixed(2)}</span>
                            </div>
                        ))
                    ) : (
                        <span>0.00</span>
                    )}
                </div>
            ),
        },
        {
            title: 'Successful Transactions',
            value: <span>{successfulCount}</span>,
        },
        {
            title: 'Failed Transactions',
            value: <span>{failedCount}</span>,
        },
    ];

    return (
        <section className="py-4 nav-body-bg" style={{ marginTop: '70px' }}>
            <Container fluid>
                <Row className="g-4 justify-content-center text-center">
                    {cards.map((card, idx) => (
                        <div key={idx} className="card-widheit2">
                            <div className="rounded-3 py-2 text-start px-3 theme-card">
                                <small className="body-text-three card-title-label">{card.title}</small>
                                <h5 className="text-h2 mt-2 card-value">{card.value}</h5>
                            </div>
                        </div>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default TransactionsCard;
